import { createSelector } from "@reduxjs/toolkit";
import { fetchingResultsCallStatusesSelector } from "features/searchResultsFacets";

export const selectTitle = (state) => state?.housingProductLocationContent?.title;
export const selectMetaDescription = (state) => state?.housingProductLocationContent?.metaDescription;
export const selectMetaRobots = (state) => state?.housingProductLocationContent?.metaRobots;
export const selectCanonical = (state) => state?.housingProductLocationContent?.canonical;
export const selectHeading1 = (state) => state?.housingProductLocationContent?.heading1;
export const selectHeading2 = (state) => state?.housingProductLocationContent?.heading2;
export const selectFooter = (state) => state?.housingProductLocationContent?.footer;
export const selectFetchStatus = (state) => state?.housingProductLocationContent?.fetchStatus;

/**
 * Composed selector to get the fetch status of the:
 * List view
 * Counts
 * Housing product location
 */
export const selectRequestStatus = createSelector(
    fetchingResultsCallStatusesSelector,
    selectFetchStatus,
    (fetchingResultsCallStatuses, housingProductLocationFetchStatus) => ({
      fetchResultListingsStatus: fetchingResultsCallStatuses.fetchResultListingsStatus,
      fetchResultCountsStatus: fetchingResultsCallStatuses.fetchResultCountsStatus,
      housingProductLocationFetchStatus,
    })
  );
